// `/app/checkout/products/$id`: gaveta "Editar produto" por cima da tela.

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { EditProductDrawer } from '../../../features/checkout/edit-product-drawer.tsx';
import { useFeatureDisabled } from '../../../features/checkout/feature-disabled.tsx';

function EditProduct() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { markDisabled } = useFeatureDisabled();
  return (
    <EditProductDrawer
      id={id}
      onClose={() => {
        void navigate({ to: '/app/checkout' });
      }}
      onFeatureDisabled={markDisabled}
    />
  );
}

export const Route = createFileRoute('/app/checkout/products/$id')({ component: EditProduct });
